import { useState } from "react";
import "./services-faq.css";
import { FaPlus, FaMinus } from "react-icons/fa";

const faqData = [
  {
    question: "What types of businesses do you work with?",
    answer:
      "We work with startups, SMEs, enterprises, and SaaS companies across industries such as FinTech, Healthcare, E-Commerce, Education, and more.",
  },
  {
    question: "Do you provide end-to-end product development?",
    answer:
      "Yes. From discovery and UI/UX design to development, deployment, and ongoing support — we handle the complete product lifecycle.",
  },
  {
    question: "Can you scale an existing application?",
    answer:
      "Absolutely. We specialize in performance optimization, architecture refactoring, cloud scaling, and feature expansion for growing products.",
  },
  {
    question: "What technologies do you specialize in?",
    answer:
      "Our core stack includes React, Next.js, Node.js, PostgreSQL, MongoDB, AWS, Docker, and modern DevOps practices.",
  },
  {
    question: "How long does a typical project take?",
    answer:
      "Timelines vary by scope, but most projects range from 4–12 weeks. We provide a clear roadmap before starting.",
  },
  {
    question: "Do you offer post-launch support?",
    answer:
      "Yes. We offer long-term maintenance, monitoring, feature upgrades, and dedicated support plans.",
  },
];

const ServicesFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="services-faq">
      <div className="services-faq__container">
        {/* HEADER */}
        <div className="services-faq__header">
          <span className="services-faq__badge">FAQs</span>

          <h2 className="services-faq__title">
            Frequently Asked{" "}
            <span className="services-faq__title-accent">Questions</span>
          </h2>

          <p className="services-faq__subtitle">
            Everything you need to know about our services, process, and
            collaboration.
          </p>
        </div>

        {/* FAQ LIST */}
        <div className="services-faq__list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`services-faq__item ${
                activeIndex === index ? "is-active" : ""
              }`}
            >
              <button
                className="services-faq__question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{item.question}</span>
                {activeIndex === index ? <FaMinus /> : <FaPlus />}
              </button>

              <div className="services-faq__answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesFAQ;
